import { AIResponse } from '@landtrustinc/design-system';
import React from 'react';

import type { ErrorMessage } from '../../types';

type ChatErrorProps = {
  msg: ErrorMessage;
  isConsecutiveAssistant?: boolean;
  retryLastMessage: () => void;
};

const ChatError: React.FC<ChatErrorProps> = ({
  msg,
  isConsecutiveAssistant = false,
  retryLastMessage,
}) => {
  return (
    <AIResponse
      key={msg.id}
      variant="error"
      onErrorRetry={retryLastMessage}
      showDisclaimer={msg.showDisclaimer}
      showHelpfulQuestion={msg.showHelpfulQuestion}
      showTitle={!isConsecutiveAssistant}
    >
      {msg.errorMessage}
    </AIResponse>
  );
};

export default ChatError;
